import React from 'react'

const LinkAddIcon = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.1818 9.82116L8.9127 11.0902C8.2107 11.7922 8.2107 12.9352 8.9127 13.6372C9.6147 14.3392 10.7577 14.3392 11.4597 13.6372L13.4578 11.6392C14.8618 10.2352 14.8618 7.95819 13.4578 6.54519C12.0538 5.14119 9.7767 5.14119 8.3637 6.54519L6.18575 8.72316C4.97975 9.92916 4.97975 11.8822 6.18575 13.0882" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10 19C14.9705 19 19 14.9705 19 10C19 5.02943 14.9705 1 10 1C5.02943 1 1 5.02943 1 10C1 14.9705 5.02943 19 10 19Z" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default LinkAddIcon